import { useFormContext } from 'react-hook-form'
import { Button } from '..'

type ResetButtonProps = {
  onClick: () => void
  title?: string
}

export const ResetButton = ({ onClick, title }: ResetButtonProps) => {
  const { reset } = useFormContext()
  return (
    <Button
      variant="text"
      onClick={() => {
        onClick?.()
        reset()
      }}
    >
      {title || 'Limpar Filtros'}
    </Button>
  )
}
